import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import qs from 'qs';
/**
 * 上传
 * @param {string} url 请求接口
 * @param {object} params 传输数据
 * @param {string} contentType 传输header contentType
 * @param {string} method 传输方法
 */

export var sendRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$url, url, _ref$params, params, _ref$contentType, contentType, _ref$method, method, _ref$headers, headers, _ref$noReturn, noReturn, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$url = _ref.url, url = _ref$url === void 0 ? '' : _ref$url, _ref$params = _ref.params, params = _ref$params === void 0 ? {} : _ref$params, _ref$contentType = _ref.contentType, contentType = _ref$contentType === void 0 ? 'application/json' : _ref$contentType, _ref$method = _ref.method, method = _ref$method === void 0 ? 'POST' : _ref$method, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers, _ref$noReturn = _ref.noReturn, noReturn = _ref$noReturn === void 0 ? true : _ref$noReturn;
            params = contentType.indexOf('json') != -1 ? _JSON$stringify(params) : qs.stringify(params);
            _context.prev = 2;
            _context.next = 5;
            return fetch(url, {
              body: params,
              headers: _objectSpread({
                'Content-Type': contentType
              }, headers),
              method: method
            });

          case 5:
            response = _context.sent;

            if (!noReturn) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", '');

          case 10:
            return _context.abrupt("return", response.json());

          case 11:
            _context.next = 17;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            console.error('fetch请求失败', url, _context.t0);
            return _context.abrupt("return", '');

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 13]]);
  }));

  return function sendRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // export const sendRequest = ({
//   url = '',
//   params = {},
//   contentType = 'application/json',
//   method = 'POST',
// }) => {
//   new Promise((resolve, reject) => {
//     if (process.env.NODE_ENV === 'development' && CONFIG_DO_NOT_UPLOAD_DATA) {
//       console.log('Before request：', url, params)
//       return
//     }
//     params = contentType.includes('json')
//       ? JSON.stringify(params)
//       : qs.stringify(params)
//     const requestObj = window.XMLHttpRequest
//       ? new XMLHttpRequest()
//       : new ActiveXObject()
//     requestObj.open(method, url, true)
//     requestObj.setRequestHeader('Content-type', contentType)
//     requestObj.send(params)
//     requestObj.onreadystatechange = () => {
//       console.log(requestObj.readyState)
//       console.log(XMLHttpRequest.DONE)
//       console.log(ActiveXObject)
//       if (requestObj.readyState === 4) {
//         if (requestObj.status === 200) {
//           resolve(requestObj.response)
//         } else {
//           reject(requestObj.response)
//         }
//       }
//     }
//   }).catch((e) => {
//     console.error('请求失败', url, e)
//   })
// }
// .then((response) => response.json())
// .then((response) => {
//   if(response.ok)
//   if (data.status === 200) resolve(data)
//   else reject('')
// })
// }).catch((e) => {
//   console.error('fetch请求失败', url, e)
// })